module.exports = __webpack_public_path__ + "static/media/shengdiao3.f5e628be.png";